import AccordionWithArrow from './accordionWithArrow'
export default AccordionWithArrow
